import { MortgageInterface } from '@app/interfaces/mortgage.interface';
import { DocumentStatusEnum } from '@app/enums/document-status.enum';

export class FillingScore3000 {
    static check(mortgage: MortgageInterface): boolean {
        return !!(
            mortgage._documents.filter((d) => d._template.groupId === 30 && !d.isArchived).length &&
            mortgage._documents
                .filter((d) => d._template.groupId === 30 && !d.isArchived)
                .every((d) => [DocumentStatusEnum.done].includes(d.status))
        );
    }
}
